import { VALID_LOCALES } from "assets/scripts/domain/i18n/utils";
export default function getLocaleSwitcherTargets(currentLocale) {
    return Object.keys(VALID_LOCALES)
        .filter(it => it !== currentLocale)
        .map(locale => ({
        locale,
        label: VALID_LOCALES[locale]
    }));
}



// WEBPACK FOOTER //
// ./src/assets/scripts/components/presentational/AppFooter/getLocaleSwitcherTargets.ts